import React from "react";
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import * as generalFunctions from "../../common/utils/generalFunctions";

export class EditDraftOrderRow extends React.Component {
  getSubTotal = (row) => {
    if (!row) {
      return 'MKT';
    }
    const unitPrice = generalFunctions.getPrice(row.price, this.props.conceptAttributes);
    // If the resolved price is explicitly market/unknown, propagate that.
    if (unitPrice === 'MKT' || unitPrice === undefined || unitPrice === null || unitPrice === '') {
      return 'MKT';
    }
    const quantity = Number(row.order) || 0;
    const numericUnitPrice = Number(unitPrice);
    // If the resolved unit price is not a valid number, treat as market/unknown.
    if (Number.isNaN(numericUnitPrice)) {
      return 'MKT';
    }
    const subtotal = numericUnitPrice * quantity;
    return generalFunctions.roundFixed(subtotal, 2);
  };

  render() {
    const row = this.props.data;
    const deleteItem = this.props.deleteItem;
    const updateLineNote = this.props.updateLineNote;
    const updateQuantity = this.props.updateQuantity;
    const disableInputFields = this.props.itemOptions && this.props.itemOptions.disableInputFields;
    const requestedShipDateIndex = this.props.headers ? this.props.headers.findIndex(x => x.name === 'shipDate') : -1;
    const requestedDeliveryDateIndex = this.props.headers ? this.props.headers.findIndex(x => x.name === 'deliveryDate') : -1;
    const price = generalFunctions.getPrice(row.price, this.props.conceptAttributes);
    const subTotal = this.getSubTotal(row);
    const cellClass = {};

    if (this.props.headers) {
      for (let i = 0; i < this.props.headers.length; i++) {
        cellClass[i] = { className: this.props.headers[i].className };
      }
    }

    const shipDateOnly = requestedShipDateIndex > -1 && requestedDeliveryDateIndex === -1;
    const shipDateFirst = shipDateOnly || ((requestedShipDateIndex > -1 && requestedDeliveryDateIndex > -1) && (requestedShipDateIndex < requestedDeliveryDateIndex));
    const requestedDateCol1 = (isShipDateFirst) => {
      const requestedDate = isShipDateFirst ? row.shipDate : row.deliveryDate;
      return <td {...cellClass[8]}>{generalFunctions.getFormattedDisplayDate(requestedDate, false, true)}</td>;
    };
    const requestedDateCol2 = (isShipDateFirst) => {
      const requestedDate = isShipDateFirst ? row.deliveryDate : row.shipDate;
      return <td {...cellClass[9]}>{generalFunctions.getFormattedDisplayDate(requestedDate, false, true)}</td>;
    };

    return (
      <tr>
        <td {...cellClass[0]}>
          <input
            type="text"
            className="form-control textbox"
            value={row.order}
            disabled={disableInputFields}
            onChange={(event) => updateQuantity(event, row)} />
        </td>
        <td {...cellClass[1]}>{row.itemNumber}</td>
        <td {...cellClass[2]}>{row.description}</td>
        <td {...cellClass[3]}>{row.unit}</td>
        <td {...cellClass[4]}>{row.pack}</td>
        <td {...cellClass[5]}>{price}</td>
        <td {...cellClass[6]}>{subTotal}</td>
        <td {...cellClass[7]}>
          <input type="text" className="form-control textbox" defaultValue={row.lineNote || ''} disabled={disableInputFields} onChange={(event) => updateLineNote(event, row)} />
        </td>
        {(requestedShipDateIndex > -1 || requestedDeliveryDateIndex > -1) ? requestedDateCol1(shipDateFirst) : null}
        {(requestedShipDateIndex > -1 && requestedDeliveryDateIndex > -1) ? requestedDateCol2(shipDateFirst) : null}
      </tr>
    );
  }
}

EditDraftOrderRow.propTypes = {
  data: PropTypes.object.isRequired,
  deleteItem: PropTypes.func.isRequired,
  updateQuantity: PropTypes.func.isRequired,
  updateLineNote: PropTypes.func.isRequired,
  headers: PropTypes.array,
  itemOptions: PropTypes.object.isRequired,
  conceptAttributes: PropTypes.array
};

export const mapStateToProps = state => {
  return {
    conceptAttributes: state.conceptAttributes
  };
};

export default connect(mapStateToProps)(EditDraftOrderRow);
